import { Directive, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appTooltipPosition]'
})
export class TooltipPositionDirective implements AfterViewInit {
  tooltip: HTMLElement;
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    this.tooltip = this.el.nativeElement.querySelector('.tooltiptext');
    this.setTooltipPosition();
  }

  @HostListener('window:resize')
  @HostListener('window:scroll')
  onWindowEvent() {
    this.setTooltipPosition();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.setTooltipPosition();
  }

  setTooltipPosition() {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const tooltipHeight = this.tooltip?.offsetHeight;
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;

    if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
      this.renderer.setAttribute(this.tooltip, 'data-position', 'top');
    } else {
      this.renderer.setAttribute(this.tooltip, 'data-position', 'bottom');
    }
  }
}
